import React, { FunctionComponent } from 'react'

import { PromoType } from '../../../../../state/configuration'
import { useProduct } from '../../../productContext'
import { PromoNoCodeModalContent } from './PromoNoCodeModalContent'
import { PromoRetailerAndProposalModalContent } from './PromoRetailerAndProposalModalContent'
import { PromoRetailerModalContent } from './PromoRetailerModalContent'
import { PromoModalContentProps } from './types'

export const PromotionModalContent: FunctionComponent<PromoModalContentProps> = (
  props,
) => {
  const { promoCode } = props
  const { product } = useProduct()
  const { promo } = product
  const promoObject = promo[promoCode]

  switch (promoObject.type) {
    case PromoType.NO_CODE:
      return <PromoNoCodeModalContent {...props} />
    case PromoType.RETAILER_CODE:
      return <PromoRetailerModalContent {...props} promoObject={promoObject} />
    case PromoType.RETAILER_AND_PROPOSAL_CODE:
      return <PromoRetailerAndProposalModalContent {...props} promoObject={promoObject} />
    default:
      return <></>
  }
}
